import React from "react";
import { Link } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";

const NotFoundPage: React.FC = () => {
	usePageTitle("ページが見つかりません");

	return (
		<div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
			<h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
			<p className="text-xl text-gray-600 mb-8">
				お探しのページが見つかりませんでした
			</p>
			<p className="text-gray-500 mb-8">
				URLが間違っているか、ページが移動または削除された可能性があります。
			</p>
			<div className="space-x-4">
				<Link
					to="/"
					className="bg-blue-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-700"
				>
					トップページに戻る
				</Link>
				<Link
					to="/events"
					className="bg-gray-100 text-gray-700 px-6 py-3 rounded-lg font-bold hover:bg-gray-200"
				>
					イベント一覧を見る
				</Link>
			</div>
		</div>
	);
};

export default NotFoundPage;
